module.exports = __webpack_public_path__ + "media/site/images/key-features/screenshots/mobile-project-settlement@2x-79c6536203e72795e6a53abcb6eb4980.png";